import React, { Fragment } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { AccountType } from '../../../../core/api/models';
import ErrorMessage from '../../../../components/text/ErrorMessage';
import { Multiselect } from 'react-widgets';
import {
  convertPascalCaseToWords,
  FollowupActivitiesOfStage,
  FollowUpActivityTypes,
  NoteTypes,
} from '../../../../core';

const UpdateForm: React.FunctionComponent<{
  onSubmit: (data: FollowupActivitiesOfStage) => void;
  onCancel: () => void;
  isSubmitting?: boolean;
  data?: FollowupActivitiesOfStage;
  error?: string;
}> = (props) => {
  const {
    control,
    handleSubmit,
    errors,
    watch,
  } = useForm<FollowupActivitiesOfStage>({
    reValidateMode: 'onChange',
    mode: 'onSubmit',
  });
  const [settingsData, setData] = React.useState(props.data);

  React.useEffect(() => {
    if (props.data) {
      setData(props.data);
    }
  }, [props.data]);

  const renderActivityType = () => {
    return (
      <div className="col-12">
        <label className="font-sm text-uppercase">Activity Type<span className="text-danger">*</span></label>
        <div className="row">
          <div className="col-12">
            <div className="form-group font-weight-semibold mb-3">
              <Controller
                control={control}
                rules={{
                  required: true,
                  validate: (value) => {
                    return !!(value.length > 0);
                  },
                }}
                name="followupActivities"
                defaultValue={settingsData?.followupActivities}
                render={({ onChange, value, name }) => (
                  <Multiselect
                    value={value}
                    data={Object.keys(FollowUpActivityTypes).map((key) => {
                      return {
                        label: convertPascalCaseToWords(key),
                        value: key,
                      };
                    })}
                    defaultValue={value}
                    textField={'label'}
                    valueField={'value'}
                    placeholder={'Select Activity Types'}
                    onChange={(val) => {
                      onChange(val?.map((x) => x.value));
                    }}
                    allowCreate="onFilter"
                    autoFocus={true}
                  />
                )}
              />
              {errors.followupActivities && (
                <ErrorMessage> Activity Type is required</ErrorMessage>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };
  const renderFollowupOnReschedule = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3">
          <Controller
            control={control}
            name="followupOnReschedule"
            defaultValue={settingsData?.followupOnReschedule}
            render={({ onChange, value, name }) => (
              <Fragment>
                <input
                  type="checkbox"
                  id={name}
                  checked={value}
                  onChange={(e) => onChange(e.target.checked)}
                />
                <label htmlFor={name}>Followup On Reschedule</label>
              </Fragment>
            )}
          />
          <ErrorMessage>{errors.followupOnReschedule?.message}</ErrorMessage>
        </div>
      </div>
    );
  };

  const renderNoteType = () => {
    return (
      <div className="col-12">
        <label className="font-sm text-uppercase">Note Type</label>
        <div className="row">
          <div className="col-12">
            <div className="form-group font-weight-semibold mb-3">
              <Controller
                control={control}
                // rules={{
                //   required: !!watch('followupActivities')?.find(
                //     (x) => x === 'note'
                //   ),
                //   // validate: (value) => {
                //   //   return !!(value.length > 0);
                //   // },
                // }}
                name="noteTypes"
                defaultValue={settingsData?.noteTypes}
                render={({ onChange, value, name }) => (
                  <Multiselect
                    value={value}
                    data={Object.keys(NoteTypes).map((key) => {
                      return {
                        label: convertPascalCaseToWords(key),
                        value: key,
                      };
                    })}
                    defaultValue={value}
                    textField={'label'}
                    valueField={'value'}
                    placeholder={'Select Activity Types'}
                    onChange={(val) => {
                      onChange(val?.map((x) => x.value));
                    }}
                    allowCreate="onFilter"
                    autoFocus={true}
                  />
                )}
              />
              {errors.noteTypes && (
                <ErrorMessage> Note Type is required</ErrorMessage>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderButton = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3 text-right pt-3">
          <button
            type="button"
            className="btn btn-outline-dark py-2 font-weight-semibold font-normal px-4 mr-1"
            onClick={props.onCancel}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="btn btn-primary py-2 font-weight-semibold font-normal px-4 "
            disabled={props.isSubmitting}
          >
            Update
          </button>
        </div>
      </div>
    );
  };

  return (
    <form onSubmit={handleSubmit(props.onSubmit)}>
      <div className="p-4">
        <h4 className="mb-3 font-weight-semibold">Update Followup Settings</h4>
        <div className="row gutter-10">
          {renderActivityType()}
          {renderFollowupOnReschedule()}
          {renderNoteType()}
          <ErrorMessage>{props.error}</ErrorMessage>
          {renderButton()}
        </div>
      </div>
    </form>
  );
};

export default UpdateForm;
